import dayjs from 'dayjs'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'

import { Meta } from '@/layouts/Meta'

import { useNotification } from '@/containers'
import styles from './maintenance.module.scss'

const Maintenance = () => {
  const router = useRouter()
  const { systemConfig } = useNotification()
  const timeStampData = Number(router?.query?.timeStamp)
  const duration = Number(router?.query?.duration)

  const minuteStart = `0${new Date(timeStampData * 1000).getMinutes()}`
  const minuteEnd = router?.query?.duration
    ? `0${new Date(timeStampData * 1000 + duration * 60 * 1000).getMinutes()}`
    : `0${new Date(timeStampData * 1000 + 1800000).getMinutes()}`
  const fromTime = router?.query?.duration
    ? dayjs(new Date(timeStampData * 1000 + duration * 60 * 1000))
    : dayjs(new Date(timeStampData * 1000 + 1800000))
  const initialTime = Number(dayjs(fromTime).diff(dayjs(), 'second'))
  const [remainTime, setRemainTime] = useState(initialTime)
  useEffect(() => {
    const countdown = initialTime * 1000
    const callBackSite = () => {
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      process.env.NEXT_PUBLIC_URL_WEBSITE &&
        (window.location.href = process.env.NEXT_PUBLIC_URL_WEBSITE)
    }
    if (initialTime) {
      setTimeout(() => {
        callBackSite()
      }, countdown)
    }
    const timer = setInterval(() => {
      setRemainTime(remainTime - 1)
    }, 1000)
    return () => clearInterval(timer)
  }, [remainTime])

  const renderTime = () => {
    return (
      <div className={styles.timeBox}>
        <div className={styles.timeFrom}>
          <span className={styles.hour}>
            {new Date(timeStampData * 1000).getHours()}
          </span>
          :<span className={styles.minute}>{minuteStart.substr(-2)}</span>
        </div>
        <span>đến</span>
        <div className={styles.timeTo}>
          <span className={styles.hour}>
            {router?.query?.duration
              ? new Date(timeStampData * 1000 + duration * 60 * 1000).getHours()
              : new Date(timeStampData * 1000 + 1800000).getHours()}
          </span>
          :<span className={styles.minute}>{minuteEnd.substr(-2)}</span>
        </div>
      </div>
    )
  }
  return (
    <div className={styles.root}>
      <Meta title='Bảo trì' description='Website đang tiến hành bảo trì' />
      <div className={styles.maintenance}>
        <div className={styles.logo}>
          <Link href='/'>
            <img
              src={`${router.basePath}/assets/images/logo-gradient.svg`}
              alt={systemConfig?.websiteBrandName}
            />
          </Link>
        </div>
        <div className={styles.row}>
          <div className={styles.text}>
            <h1 className={styles.heading1}>Hệ thống bảo trì</h1>
            <p className='text-dark-100'>
              {systemConfig?.websiteBrandName} đang tiến hành nâng cấp hệ thống,
              rất mong quý khách hàng thông cảm và tiếp tục sử dụng dịch vụ của
              {systemConfig?.companyWebsite}
            </p>
            <div className={styles.boxCountdown}>
              <h6 className={styles.label}>Thời gian bảo trì dự kiến:</h6>
              <div className={styles.expected}>
                {timeStampData ? renderTime() : '30 phút'}
              </div>
            </div>
            <span className='text-dark-100'>
              Mọi yêu cầu vui lòng liên hệ hotline để được chăm sóc tốt nhất
            </span>
            <a
              className={`btn btn-default ${styles.hotLine}`}
              href={`tel:${systemConfig?.companyHotline}`}
            >
              Hotline: {systemConfig?.companyHotline}
            </a>
          </div>
          <div className={styles.image}>
            <picture>
              <source
                media='(max-width: 768px)'
                srcSet={`${router.basePath}/assets/images/icon-maintain-mobile.svg`}
              />
              <img
                src={`${router.basePath}/assets/images/icon-maintain-desktop.svg`}
                alt={systemConfig?.websiteBrandName}
              />
            </picture>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Maintenance
